import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SliderFilterIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 21 21" {...props}>
            <path
                id="Vector"
                d="M5.94642 11.0083H2.77734"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                id="Vector_2"
                d="M17.7789 10.9541L9.94629 10.9541"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle id="Ellipse 19" cx="7.94629" cy="10.8369" r="1.5" stroke="currentColor" />

            <path
                id="Vector_3"
                d="M14.6923 5.63623L17.8613 5.63623"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                id="Vector_4"
                d="M2.86011 5.7002H10.6934"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                id="Ellipse 19_2"
                cx="12.6934"
                cy="5.53711"
                r="1.5"
                transform="rotate(180 12.6934 5.53711)"
                stroke="currentColor"
            />

            <path
                id="Vector_5"
                d="M14.6923 16.1655L17.8613 16.1655"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                id="Vector_6"
                d="M2.8596 16.2295H10.6934"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                id="Ellipse 19_3"
                cx="12.6934"
                cy="16.0371"
                r="1.5"
                transform="rotate(180 12.6934 16.0371)"
                stroke="currentColor"
            />
        </SvgIcon>
    );
};
